<template>
  <Breadcrumb :items="breadcrumbs" />
  <div class="container-fluid my-3">

    <div class="filter my-3">
      <div class="filter-head">
        <h4>{{ group ? `طلاب مجموعة ${group.name}` : 'تفاصيل المجموعة' }} ({{ total }})</h4>
        <div class="buttons">
          <router-link v-if="group" :to="`/grades/${gradeSlug}/groups/${group.id}/whatsapp`" class="btn btn-success text-white">
            <i class="pi pi-whatsapp me-1"></i> واتساب
          </router-link>
          <router-link v-if="group" :to="`/grades/${gradeSlug}/groups/${group.id}/messages`" class="btn btn-secondary text-white">
            <i class="pi pi-envelope me-1"></i> رسائل الحجز
          </router-link>
          <button class="btn btn-outline-primary" @click="openBulkAddDialog">
            <i class="pi pi-users me-1"></i> إضافة جماعية
          </button>
          <button class="btn PrimaryButton" @click="openAddStudentDialog">
            <i class="pi pi-user-plus me-1"></i> إضافة طالب
          </button>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-4 col-md-12 col-12">
          <div class="form-group">
            <label>ابحث</label>
            <input type="search" class="form-control" placeholder="ابحث بالاسم أو رقم ولي الأمر" v-model="word" @keyup="debounceFetch">
          </div>
        </div>
        <div class="col-lg-2 col-md-6 col-12">
          <div class="form-group d-flex flex-column">
            <label>الجنس</label>
            <Dropdown v-model="gender" :options="genderList" optionLabel="title" showClear placeholder="الكل" class="w-100" @change="fetchStudents()" />
          </div>
        </div>
        <div class="col-lg-2 col-md-6 col-12">
          <div class="form-group d-flex flex-column">
            <label>حالة الحجز</label>
            <Dropdown v-model="reservationStatus" :options="statusList" optionLabel="title" showClear placeholder="الكل" class="w-100" @change="fetchStudents()" />
          </div>
        </div>
        <div class="col-lg-2 col-md-6 col-12">
          <div class="d-flex">
            <div class="form-group d-flex flex-column mx-1">
              <label class="non_opacity">Excel</label>
              <button type="button" class="btn btn-success px-3" @click="exportToExcel">
                <i class="pi pi-file-excel"></i>
              </button>
            </div>
            <div class="form-group d-flex flex-column mx-1">
              <label class="non_opacity">PDF</label>
              <button type="button" class="btn btn-danger px-3" v-print="'#groupStudentsExportTable'">
                <i class="pi pi-file-pdf"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <table class="table table-striped">
          <thead>
            <tr>
              <th>#</th>
              <th>الطالب</th>
              <th>رقم ولي الأمر</th>
              <th>حالة الحجز</th>
              <th>التحكم</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="loading">
              <td colspan="5" class="text-center py-4">
                <i class="pi pi-spin pi-spinner" style="font-size:1.5rem;"></i>
              </td>
            </tr>
            <tr v-else-if="students.length === 0">
              <td colspan="5" class="text-center py-4 text-muted">لا يوجد طلاب في هذه المجموعة</td>
            </tr>
            <tr v-for="(s, index) in students" :key="s.id" v-else>
              <td>{{ index + 1 }}</td>
              <td>{{ s.name }}</td>
              <td>{{ s.parent_phone }}</td>
              <td>
                <span v-if="s.reservation_status == 1" class="status-badge status-badge--accepted">مقبول</span>
                <span v-else-if="s.reservation_status == 2" class="status-badge status-badge--rejected">مرفوض</span>
                <span v-else-if="s.reservation_status == 3" class="status-badge status-badge--waiting">انتظار الشهادة</span>
                <span v-else class="status-badge status-badge--pending">معلق</span>
              </td>
              <td>
                <button class="btn btn-danger text-white mx-1" :tooltip="'إزالة من المجموعة'" flow="up" @click="removeStudent(s)">
                  <i class="pi pi-times"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>

        <table id="groupStudentsExportTable" class="table table-striped" style="display:none">
          <thead>
            <tr>
              <th>اسم الطالب</th>
              <th>رقم ولي الأمر</th>
              <th>الجنس</th>
              <th>حالة الحجز</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="s in students" :key="s.id">
              <td>{{ s.name }}</td>
              <td>{{ s.parent_phone }}</td>
              <td>{{ genderLabel(s.gender) }}</td>
              <td>{{ statusLabel(s.reservation_status) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

  </div>

  <!-- Add single student -->
  <Dialog v-model:visible="addDialogVisible" modal header="إضافة طالب" :style="{ width: '30rem' }">
    <div class="form-group d-flex flex-column">
      <label>ابحث عن طالب</label>
      <Dropdown
        v-model="selectedStudent"
        :options="availableStudents"
        optionLabel="name"
        filter
        :filterFields="['name', 'parent_phone']"
        placeholder="اختر طالباً"
        @filter="onAvailableFilter"
        class="w-100"
      >
        <template #option="slotProps">
          <span>{{ slotProps.option.name }} — {{ slotProps.option.parent_phone }}</span>
        </template>
      </Dropdown>
    </div>
    <div class="mt-3 text-end">
      <button class="btn PrimaryButton" :disabled="!selectedStudent || addingStudent" @click="addStudent">
        <i class="pi pi-spin pi-spinner-dotted" v-if="addingStudent"></i>
        {{ addingStudent ? 'جاري الإضافة...' : 'إضافة' }}
      </button>
    </div>
  </Dialog>

  <!-- Bulk add -->
  <Dialog v-model:visible="bulkDialogVisible" modal header="إضافة جماعية للطلاب" :style="{ width: '35rem' }">
    <div class="row g-2 mb-2">
      <div class="col-6">
        <div class="form-group d-flex flex-column">
          <label>الجنس</label>
          <Dropdown v-model="availableGender" :options="genderList" optionLabel="title" showClear placeholder="الكل" class="w-100" @change="fetchAvailableStudents()" />
        </div>
      </div>
      <div class="col-6">
        <div class="form-group d-flex flex-column">
          <label>حالة الحجز</label>
          <Dropdown v-model="availableReservationStatus" :options="statusList" optionLabel="title" showClear placeholder="الكل" class="w-100" @change="fetchAvailableStudents()" />
        </div>
      </div>
    </div>
    <div class="form-group d-flex flex-column">
      <label>اختر الطلاب</label>
      <MultiSelect
        v-model="bulkSelectedStudents"
        :options="availableStudents"
        optionLabel="name"
        filter
        :filterFields="['name', 'parent_phone']"
        placeholder="اختر الطلاب"
        :maxSelectedLabels="3"
        class="w-100"
        @filter="onAvailableFilter"
      />
    </div>
    <div class="mt-3 text-end">
      <button class="btn PrimaryButton" :disabled="bulkSelectedStudents.length === 0 || bulkAdding" @click="bulkAddStudents">
        <i class="pi pi-spin pi-spinner-dotted" v-if="bulkAdding"></i>
        {{ bulkAdding ? 'جاري النقل...' : `نقل ${bulkSelectedStudents.length} طالب` }}
      </button>
    </div>
  </Dialog>
</template>

<script>
import axios from 'axios';
import Swal from 'sweetalert2';
import * as XLSX from 'xlsx/xlsx.mjs';
import Dialog from 'primevue/dialog';
import Dropdown from 'primevue/dropdown';
import MultiSelect from 'primevue/multiselect';
import Breadcrumb from '@/components/global/breadcrumb.vue';
import { useGradeStore } from '@/stores/useGradeStore.js';

export default {
  name: 'GradeGroupShow',
  components: { Dialog, Dropdown, MultiSelect, Breadcrumb },

  data() {
    return {
      group: null,
      students: [],
      total: 0,
      loading: true,
      word: '',
      searchTimeout: null,
      gender: null,
      reservationStatus: null,
      genderList: [
        { id: 1, title: 'ولد' },
        { id: 2, title: 'بنت' },
      ],
      statusList: [
        { id: 1, title: 'مقبول' },
        { id: 0, title: 'معلق' },
        { id: 2, title: 'مرفوض' },
      ],

      availableStudents: [],
      availableWord: '',
      availableGender: null,
      availableReservationStatus: null,
      addDialogVisible: false,
      selectedStudent: null,
      addingStudent: false,

      bulkDialogVisible: false,
      bulkSelectedStudents: [],
      bulkAdding: false,
    };
  },

  computed: {
    gradeStore() { return useGradeStore(); },
    gradeSlug() { return this.$route.params.gradeSlug; },
    groupId() { return this.$route.params.groupId; },
    breadcrumbs() {
      return [
        { name: 'الرئيسية', path: '/' },
        { name: 'مجموعات الطلاب', path: `/grades/${this.gradeSlug}/groups` },
        { name: this.group?.name ?? 'المجموعة', path: `/grades/${this.gradeSlug}/groups/${this.groupId}` },
      ];
    },
  },

  methods: {
    debounceFetch() {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => this.fetchStudents(), 800);
    },

    async fetchGroup() {
      const { data } = await axios.get(`/groups/${this.groupId}`);
      this.group = data.data;
    },

    async fetchStudents() {
      this.loading = true;
      try {
        const { data } = await axios.get(`/groups/${this.groupId}/students`, {
          params: {
            word: this.word || undefined,
            gender: this.gender?.id,
            reservation_status: this.reservationStatus ? this.reservationStatus.id : undefined,
          },
        });
        this.students = data.data ?? [];
        this.total = this.students.length;
      } catch {
        this.students = [];
      } finally {
        this.loading = false;
      }
    },

    genderLabel(gender) {
      return gender == 2 ? 'بنت' : 'ولد';
    },

    statusLabel(status) {
      if (status == 1) return 'مقبول';
      if (status == 2) return 'مرفوض';
      if (status == 3) return 'انتظار الشهادة';
      return 'معلق';
    },

    exportToExcel() {
      const rows = this.students.map(s => ({
        'اسم الطالب': s.name,
        'رقم ولي الأمر': s.parent_phone,
        'الجنس': this.genderLabel(s.gender),
        'حالة الحجز': this.statusLabel(s.reservation_status),
      }));
      const ws = XLSX.utils.json_to_sheet(rows);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'الطلاب');
      XLSX.writeFile(wb, `طلاب-${this.group?.name || 'مجموعة'}.xlsx`);
    },

    async fetchAvailableStudents(word) {
      try {
        const w = word !== undefined ? word : this.availableWord;
        const { data } = await axios.get(`/groups/${this.groupId}/available-students`, {
          params: {
            word: w || undefined,
            gender: this.availableGender?.id,
            reservation_status: this.availableReservationStatus ? this.availableReservationStatus.id : undefined,
          },
        });
        this.availableStudents = data.data ?? [];
      } catch {
        this.availableStudents = [];
      }
    },

    onAvailableFilter(e) {
      this.availableWord = e.value;
      this.fetchAvailableStudents();
    },

    openAddStudentDialog() {
      this.selectedStudent = null;
      this.availableWord = '';
      this.availableGender = null;
      this.availableReservationStatus = null;
      this.fetchAvailableStudents();
      this.addDialogVisible = true;
    },

    openBulkAddDialog() {
      this.bulkSelectedStudents = [];
      this.availableWord = '';
      this.availableGender = null;
      this.availableReservationStatus = null;
      this.fetchAvailableStudents();
      this.bulkDialogVisible = true;
    },

    async addStudent() {
      if (!this.selectedStudent) return;
      this.addingStudent = true;
      try {
        const { data } = await axios.post(`/groups/${this.groupId}/students`, {
          student_id: this.selectedStudent.id,
        });
        if (data.status) {
          Swal.fire('', data.message, 'success');
          this.addDialogVisible = false;
          this.fetchGroup();
          this.fetchStudents();
        } else {
          Swal.fire('', data.message, 'error');
        }
      } catch (error) {
        Swal.fire('', error.response?.data?.message || 'حدث خطأ', 'error');
      } finally {
        this.addingStudent = false;
      }
    },

    async bulkAddStudents() {
      if (this.bulkSelectedStudents.length === 0) return;
      this.bulkAdding = true;
      try {
        const { data } = await axios.post(`/groups/${this.groupId}/students/bulk`, {
          student_ids: this.bulkSelectedStudents.map(s => s.id),
        });
        if (data.status) {
          Swal.fire('', data.message, 'success');
          this.bulkDialogVisible = false;
          this.fetchGroup();
          this.fetchStudents();
        } else {
          Swal.fire('', data.message, 'error');
        }
      } catch (error) {
        Swal.fire('', error.response?.data?.message || 'حدث خطأ', 'error');
      } finally {
        this.bulkAdding = false;
      }
    },

    removeStudent(student) {
      Swal.fire({
        title: `إزالة "${student.name}" من المجموعة؟`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'إزالة',
        cancelButtonText: 'رجوع',
      }).then(r => {
        if (!r.isConfirmed) return;
        axios.delete(`/groups/${this.groupId}/students/${student.id}`).then(({ data }) => {
          if (data.status) {
            Swal.fire('', data.message, 'success');
            this.fetchGroup();
            this.fetchStudents();
          }
        });
      });
    },
  },

  async mounted() {
    if (!this.gradeStore.activeGrades.length) {
      await this.gradeStore.fetchActiveGrades();
    }
    await this.fetchGroup();
    this.fetchStudents();
  },
};
</script>

<style scoped>
</style>
